const ANNOUNCEMENT_VIDEO_STYLE = [
  'display: block',
  'width: min(100%, 360px)',
  'min-height: 180px',
  'height: auto',
  'aspect-ratio: 16 / 9',
  'object-fit: contain',
  'background: #111827',
  'border-radius: 6px',
  'margin: 8px 0'
].join('; ');

/**
 * Normalize announcement rich text so uploaded videos keep a visible frame in Electron.
 */
export const normalizeAnnouncementContent = (html?: string | null): string => {
  if (!html) {
    return '';
  }

  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return html;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll('video').forEach((video) => {
    video.setAttribute('controls', 'controls');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');

    const currentStyle = video.getAttribute('style') || '';
    video.setAttribute('style', `${currentStyle}; ${ANNOUNCEMENT_VIDEO_STYLE}`);
  });

  return doc.body.innerHTML;
};
